@if (problem_template.fieldsPrefix !== '') {
  <div  class="mb-4">
    {{problem_template.fieldsPrefix}}
  </div>
}
@for (cluster of problem_template.clusters; track cluster) {
  <div class="mt-1 mb-4">
    <div [innerHTML]="cluster.clusterPrefix"></div>
    @for (field of cluster.fields; track field; let i = $index) {
      <div>
        <div [innerHTML]="field.formatPrefix" class="font-semibold"></div>
        @if (field.type === 'TEXT') {
          <div class="mt-1">
            <input [disabled]="review" class="input" [(ngModel)]="field.recordedAnswer" [value]="field.recordedAnswer" (input)="onTextChange(field.recordedAnswer, field.id)"/>
          </div>
        }
        @if (field.type === 'MULTI_RADIO') {
          <fieldset [id]="field.id">
            @for (answer of field.answers; track answer) {
              <div>
                <!-- TODO fix styling for radio buttons and label -->
                @for (display of answer.choice.display_order; track display) {
                  <div class="flex items-center mb-4" [ngClass]="{'bg-green-100 border border-green-500 text-green-800 rounded-sm': display.correct && review}">
                    <input [disabled]="review" type="radio" (change)="onCheckBoxSelection(display.value, field.id)" [checked]="field.recordedAnswer === display.value" [value]="display.value" [(ngModel)]="field.recordedAnswer" [name]="field.id + i" [style]="radioStyle"/>
                    @if (checkForHTMLTags(display.formatted)) {
                      <label [innerHTML]="display.formatted"></label>
                    }
                    @else if (!checkForHTMLTags(display.formatted)) {
                      <label [innerText]="display.formatted"></label>
                    }
                  </div>
                }
              </div>
            }
          </fieldset>
        }
        @if (field.type === 'MULTI_DROPMENU') {
          <div class="my-1">
            @for (answer of field.answers; track answer) {
              <div>
                <select class="input" [disabled]="review" (change)="onSelectChange($event, field.id)">
                  @for (display of answer.choice.display_order; track display) {
                    <option [value]="display.value" [selected]="field.recordedAnswer === display.value">{{display.formatted}}</option>
                  }
                </select>
              </div>
            }
          </div>
        }
        <div [innerHTML]="field.formatPostfix"></div>
      </div>
    }
  </div>
}
@if (problem_template.fieldsPostfix !== '') {
  <div class="mt-5">
    {{problem_template.fieldsPostfix}}
  </div>
}
